import { createRouter, createWebHistory } from 'vue-router';
import { authGuard, errorHandler } from './guards';
import { ROUTES } from './routes';

const router = createRouter({
  history: createWebHistory('/new-admin/'),
  routes: ROUTES,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

router.beforeEach(async (to, from, next) => { return authGuard(to, from, next) });

router.onError((err, to) => errorHandler(err, to));

export default router;
